import React from "react";
import { FiLogOut } from "react-icons/fi";
import userPic from "../assets/user.png";
import useAuth from "../useAuth";

export const ProfilePage = () => {
  const { user, logout } = useAuth();

  console.log(user);

  return (
    <div className="w-full mt-4 md:mt-20 flex items-center justify-center py-6 md:py-10 px-4">
      <div className="w-full max-w-lg border border-slate-200 bg-white rounded-3xl md:rounded-[2.5rem] shadow-2xl p-6 md:p-10 backdrop-blur-3xl">
        {/* Header */}
        <div className="flex items-center gap-4 mb-6">
          <img
            src={user?.profilePhoto || userPic}
            alt="Profile"
            className="w-20 h-20 rounded-full border-4 border-blue-200 shadow-md object-cover"
          />
          <div>
            <h2 className="text-2xl font-bold text-slate-900 tracking-tight">
              {user?.fullName || user?.name || "User"}
            </h2>
            <p className="text-xs text-slate-400 font-black uppercase tracking-widest mt-1">
              {user?.designation || "—"} | {user?.userType || "User"}
            </p>
          </div>
        </div>

        {/* Info Fields */}
        <div className="space-y-4 text-slate-700">
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">📧 Username:</span>
            <span>{user?.email || "---"}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">📞 Mobile:</span>
            <span>{user?.mobile || "---"}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">🆔 User Type:</span>
            <span className="uppercase">{user?.userType || "---"}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">✅ Verified:</span>
            <span>Yes</span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">🕓 Registered At:</span>
            <span>
              {user?.createdAt
                ? new Date(user.createdAt).toLocaleString("en-IN")
                : "---"}
            </span>
          </div>
        </div>

        {/* Actions */}
        <div className="mt-10 flex justify-center">
          <button
            onClick={logout}
            className="flex items-center gap-3 px-10 py-4 rounded-2xl text-white bg-indigo-600 hover:bg-indigo-700 transition shadow-xl shadow-indigo-100 font-bold active:scale-95"
          >
            <FiLogOut size={18} />
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};
